module.exports = __webpack_public_path__ + "ac2114ccea6ed567971db6a1e6663530.png";